module.exports = __webpack_public_path__ + "img/goods4_6.b4caa593.jpg";